export default __webpack_public_path__ + "static/media/public_illustration.3da8a5b1.png";